/**
 * Module dependencies.
 */

import { Context, createContext, useContext } from 'react';

/**
 * Export `FilterType` type.
 */

export type FilterType = string;

/**
 * Export `Value` type.
 */

export type Value = string | number | boolean;

/**
 * Export `Filter` type.
 */

export type Filter = {
  [key: string]: {
    [key: string]: Value;
  };
};

/**
 * Export `Filters` type.
 */

export type Filters = Filter | any;

/**
 * `Result` type.
 */

type Result = {
  filters: Filters;
  submittedFilters: Filters;
};

/**
 * Export `FiltersListContext` context.
 */

export const FiltersListContext: Context<{
  filters?: Filters;
  isFilterSelected?: (filterType: FilterType, value: Value) => boolean;
  omitUrl?: boolean;
  onSet?: (filterType: FilterType, value: Value) => Result;
  onSubmit?: () => Result;
  onSubmitClear?: () => Result;
  onSubmitRemove?: (filterType: FilterType, value: Value) => Result;
  reset?: () => Result;
  submittedFilters?: Filters;
}> = createContext({});

/**
 * Export `useFiltersList` hook.
 */

export const useFiltersList = () => useContext(FiltersListContext);
